import { render, staticRenderFns } from "./NovoCampaign.vue?vue&type=template&id=4be40424&"
import script from "./NovoCampaign.vue?vue&type=script&lang=js&"
export * from "./NovoCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports